import React from 'react';
import { IconProps } from '../types';

export const ContentCreationMarketingIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <line
            x1="9"
            y1="13.6666"
            x2="12.3333"
            y2="13.6666"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <line
            x1="15.6666"
            y1="13.6666"
            x2="21.6666"
            y2="13.6666"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <line
            x1="9"
            y1="17.6666"
            x2="15"
            y2="17.6666"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <line
            x1="9"
            y1="9.66663"
            x2="15"
            y2="9.66663"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <line
            x1="9"
            y1="5.66663"
            x2="21.6667"
            y2="5.66663"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
        <path
            d="M9 27.3334C9.55228 27.3334 10 26.8857 10 26.3334C10 25.7811 9.55228 25.3334 9 25.3334C8.44772 25.3334 8 25.7811 8 26.3334C8 26.8857 8.44772 27.3334 9 27.3334Z"
            fill={color}
        />
        <path
            d="M11.6666 27.3334C12.2189 27.3334 12.6666 26.8857 12.6666 26.3334C12.6666 25.7811 12.2189 25.3334 11.6666 25.3334C11.1143 25.3334 10.6666 25.7811 10.6666 26.3334C10.6666 26.8857 11.1143 27.3334 11.6666 27.3334Z"
            fill={color}
        />
        <path
            d="M14.3334 27.3334C14.8857 27.3334 15.3334 26.8857 15.3334 26.3334C15.3334 25.7811 14.8857 25.3334 14.3334 25.3334C13.7811 25.3334 13.3334 25.7811 13.3334 26.3334C13.3334 26.8857 13.7811 27.3334 14.3334 27.3334Z"
            fill={color}
        />
        <rect
            x="5"
            y="1"
            width="22"
            height="30"
            rx="2"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="square"
        />
    </svg>
);
